export const roomEN = "<p>Discover a holiday room in Saint-Rémy-de-Provence, perfect for 2 people, located within the <strong>Résidence Melody</strong>, a calm and leafy residence just a 10-minute walk from the city center.</p>\n" +
  "<h3>🏠 House Rules</h3>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p><strong>Non-smoking studio</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Adults only</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>No pets allowed</strong></p></li></ul>\n" +
  "<h3>⭐ Comfort & Amenities</h3>\n" +
  "<p>This 23 m² room offers all the comfort you need for a successful stay in Provence:</p>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p><strong>Living room</strong> with <strong>fully equipped kitchen</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>1 bathroom</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Private terrace</strong>, perfect for outdoor meals</p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Air conditioning</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Free high-speed Wi-Fi</strong></p>\n" +
  "</li>\n" +
  "</ul>\n" +
  "<h3>🌿 Wellness & Relaxation</h3>\n" +
  "<p>The residence features facilities designed for relaxation:</p>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p><strong>Heated outdoor swimming pool</strong>, accessible all year round</p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Jacuzzi</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Landscaped garden</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Private free parking</strong></p>\n" +
  "</li>\n" +
  "</ul>\n" +
  "<h3>📍 Ideal Location</h3>\n" +
  "<p>Located at <strong>4 Allée des Amandiers</strong>, the apartment enjoys a <strong>privileged position</strong>:</p>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p>Shops, restaurants, and Provençal streets <strong>just a few minutes on foot</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p>Close to the <strong>Alpilles</strong>, hiking trails, and Provence tourist sites</p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p>Perfect for exploring <strong>Saint-Rémy-de-Provence, Les Baux-de-Provence</strong>, or <strong>Avignon</strong></p>\n" +
  "</li>\n" +
  "</ul>\n" +
  "<h3>💛 An Authentic Stay in Provence</h3>\n" +
  "<p>This apartment is perfect for:<br></p>\n" +
  "<p>✔️ Couples<br></p>\n" +
  "<p>✔️ Travelers seeking tranquility<br></p>\n" +
  "<p>✔️ Wellness or discovery stays</p>\n" +
  "<p></p>\n" +
  "<p>Enjoy a <strong>relaxing stay</strong> in a warm residence combining <strong>modern comfort</strong>, <strong>nature</strong>, and <strong>Provençal authenticity</strong>.</p>"
